import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';

const tags = {
  getReferralUsers: 'getReferralUsers',
  setReferralBonus: 'setReferralBonus',
};

export const referralCodeApi = createApi({
  reducerPath: 'referralCodeApi',
  tagTypes: [tags.getReferralUsers, tags.setReferralBonus],
  endpoints: (builder) => ({
    getReferralUsers: builder.query({
      query: (queryParams) => {
        const [pk, pageNumber, pageSize] = queryParams;

        const params = {
          pk: pk ? `USER#${pk}` : pk,
          page_number: pageNumber,
          page_size: pageSize,
        };

        return ({
          method: 'get', 
          url: `/admin/user-ref-users?${serialize(params)}`,
        });
      },
      providesTags: [tags.getReferralUsers],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
      transformResponse: (data) => {
        return {
          list: data.ref_user_list || [],
          count: data.page_amount || 0,
          pageNumber: data.page_number || 1,
        };
      },
    }),
    getUsersWithRef: builder.query({
      query: ({ page_number, page_size }) => {
        const params = { page_number, page_size };
        return {
          method: 'get',
          url: `/admin/user-with-ref?${serialize(params)}`,
        };
      },
      transformResponse: (data) => {
        return {
          list: data.ref_user_stats || [],
          count: data.page_amount || 0,
          pageNumber: data.page_number || 1,
        };
      },
    }),
    setReferralBonus: builder.mutation({
      query: ({ user_pk, amount }) => ({
        method: 'post',
        url: '/manual/set-bonus',
        body: {
          user_pk,
          amount
        }
      }),
      invalidatesTags: [tags.getReferralUsers],
    }),
  }),
});

export const referralCodeParams = createSlice({
  name: 'referralCodeParams',
  initialState: {
    pk: '',
    page: 1,
    limit: 50,
  },
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const {
  useGetReferralUsersQuery,
  useGetUsersWithRefQuery,
  useSetReferralBonusMutation,
} = referralCodeApi;

export const { setParams } = referralCodeParams.actions;
export const referralCodeParamsReducer = referralCodeParams.reducer;
export const referralCodeParamsSelector = (state) => state.referralCodeParams; 